import React from 'react';
import { Tooltip } from '@beehive/components';
import { financial } from 'utils/number';
import { isBlank } from 'utils/object';
import _ from 'lodash';
import { disabledDate } from 'utils/date';
import {
  FileListShow,
  MoneyShow,
  ProductNameShow,
  SelectShow,
  TimeShow,
} from 'containers/OutBidding/components/utils';
import {nameEmailSearchHandler, transformBlobidsToFileList} from '../../utils';
import { enums } from 'services/api';

export const getFormItemList = (params: any = {}) => {
  const { optionsMap, formData, setFormData, editFields } = params;
  const {
    demand_categories = [],
    product = [],
    quote_currencies = [],
    business = [],
  } = optionsMap;

  const {
    l1_category_id,
    product_id,
    bidding_business_ids,
    expect_begin_at,
    expect_end_at,
    budget,
    currency,
    l2_category_id,
    bidding_type_v2,
    product_name,
    background, // 需求背景
    expectation,// 需求预期
    bidding_background_attachments,// 补充说明文件
    bidding_desensitization_attachments, // 需求脱敏文档
  } = formData;

  const l1_demand_categories = demand_categories
    .filter((v: any) => v.level === 0)
    .map((cat: any) => ({ name: cat.name, value: cat.id }));

  let l2_demand_categories = [];

  const peerL2Item = demand_categories.find(
    (v: any) => v.value === l1_category_id
  );
  if (peerL2Item) {
    l2_demand_categories = peerL2Item.children.map((v: any) => ({
      name: v.name,
      value: v.id,
    }));
  }

  const haveSlectProduct = !isBlank(product_id);
  const tooltipForProduct = !haveSlectProduct ? '请先选择"所属产品"' : null;

  const formList: Record<string, any>[] = [
    // 删除所属产品展示
    // {
    //   key: 'product_id',
    //   label: '所属产品',
    //   required: true,
    //   childProps: {
    //     componentClass: 'treeSelect',
    //     options: product,
    //     mode: 'select',
    //     isMultiple: true,
    //     searchEnable: true,
    //     value: product_name,
    //     onChange(item: any) {
    //       const productCode = _.get(item, ['extra', 'option', 'identifier']);
    //       const val = item.value;
    //
    //       setFormData({
    //         ...formData,
    //         product_id: val,
    //         product_code: productCode,
    //         project_number: undefined,
    //         before_number: undefined,
    //         project_principals_attributes: undefined,
    //         bidding_business_ids: undefined,
    //       });
    //     },
    //     // showComponent: <ProductNameShow id={product_id} options={product} />,
    //   },
    // },
    {
      key: 'bidding_type_v2',
      label: '比选需求类型',
      childProps: {
        componentClass: 'select',
        options: enums.BiddingTypeV2Enum.values(),
        mode: 'select',
        value: bidding_type_v2,
        showComponent: (
          <SelectShow id={bidding_type_v2} options={enums.BiddingTypeV2Enum.values()} />
        ),
      },
    },
    // {
    //   key: 'l1_category_id',
    //   label: '需求类型（一级）',
    //   childProps: {
    //     componentClass: 'select',
    //     options: l1_demand_categories,
    //     mode: 'select',
    //     value: l1_category_id,
    //     showComponent: (
    //       <SelectShow id={l1_category_id} options={l1_demand_categories} />
    //     ),
    //   },
    // },
    // {
    //   key: 'l2_category_id',
    //   label: '需求类型（二级）',
    //   required: !isBlank(l1_category_id),
    //   childProps: {
    //     componentClass: 'select',
    //     options: l2_demand_categories,
    //     mode: 'select',
    //     value: l2_category_id,
    //     showComponent: (
    //       <SelectShow id={l2_category_id} options={l2_demand_categories} />
    //     ),
    //   },
    // },
    editFields.includes('budget')
      ? [
        {
          key: 'budget',
          label: '需求总预算',
          required: true,
          itemColProps: { span: 9 },
          childProps: {
            componentClass: 'inputNumber',
            placeholder: '请输入预算金额',
            hideHandle: true,
            min: 0,
            precision: 2,
            formatter: (value: number) => financial(value, true),
            value: budget,
          },
        },
        {
          key: 'currency',
          label: <span style={{ visibility: 'hidden' }}>__</span>,
          itemColProps: { span: 3 },
          itemLabelColProps: { span: 0 },
          itemInputColProps: { offset: 2, span: 22 },
          className: 'currency',
          childProps: {
            componentClass: 'select',
            options: quote_currencies,
            mode: 'select',
            value: currency,
            showComponent: <SelectShow id={currency} options={quote_currencies} />,
          },
        },
      ]
      : {
        key: 'budget',
        label: '需求总预算',
        childProps: {
          showComponent: <MoneyShow value={budget} currency={currency} options={quote_currencies} />
        },
      },
    {
      key: 'bidding_business_ids',
      label: '比选招采人员',
      childProps: {
        componentClass: 'select',
        options: business,
        mode: 'select',
        isMultiple: true,
        disabled: !haveSlectProduct,
        searchEnable: true,
        typeConfig: {
          multiple: {
            showSelectAllOption: true,
          },
        },
        error: tooltipForProduct,
        value: bidding_business_ids,
        searchHandle: nameEmailSearchHandler,
        renderElement: (option: any) => {
          return (
            <Tooltip
              title={
                `${option.name}` + (option.email ? `（${option.email}）` : '')
              }
              overlayStyle={{ maxWidth: 400 }}
            >
              {option.name}
            </Tooltip>
          );
        },
        showComponent: (
          <SelectShow id={bidding_business_ids} options={business} />
        ),
      },
    },
    {
      key: 'expect_begin_at',
      label: '需求预计执行开始日期',
      required: true,
      childProps: {
        componentClass: 'datePicker',
        value: expect_begin_at,
        showComponent: <TimeShow value={expect_begin_at} />,
      },
    },
    {
      key: 'expect_end_at',
      label: '需求预计执行结束日期',
      required: true,
      childProps: {
        componentClass: 'datePicker',
        value: expect_end_at,
        disabledDate: (value: any) => disabledDate(value, expect_begin_at),
        showComponent: <TimeShow value={expect_end_at} />,
      },
    },
    {
      key: 'bidding_background_attachments',
      label: '补充说明文件',
      required: true,
      childProps: {
        componentClass: 'upload',
        showComponent: <FileListShow list={transformBlobidsToFileList(bidding_background_attachments)} />,
      },
    },
    {
      key: 'bidding_desensitization_attachments',
      label: '需求脱敏文档',
      required: true,
      childProps: {
        componentClass: 'upload',
        showComponent: <FileListShow list={transformBlobidsToFileList(bidding_desensitization_attachments)} />,
      },
    },
    // {
    //   key: 'background',
    //   label: '需求背景',
    //   required: true,
    //   itemColProps: { span: 24 },
    //   childProps: {
    //     componentClass: 'textarea',
    //     showComponent: <div>{background}</div>,
    //   },
    // },
    // {
    //   key: 'expectation',
    //   label: '需求预期',
    //   required: true,
    //   itemColProps: { span: 24 },
    //   childProps: {
    //     componentClass: 'textarea',
    //     showComponent: <div>{expectation}</div>,
    //   },
    // },
  ].filter((v) => v);

  formList.forEach((v) => {
    v.itemColProps = v.itemColProps || { span: 4 };

    if (v.childProps && !v.childProps.onChange) {
      v.childProps.onChange = ({ formItemKey, value }: any) => {
        const newFormData = _.cloneDeep(formData);
        newFormData[formItemKey] = value;
        setFormData(newFormData);
      };
    }

    if (v.childProps) {
      v.childProps.isShow = true;
    }

    if (editFields.includes(v.key) && v.childProps) {
      v.childProps.isShow = false;
    }
  });
  return formList;
};
